/**
 * Includes all available sidebar plugins
 */
define('post-editor/sidebar-plugins',['post-editor/table-plugin', 'post-editor/margin-plugin',
        'post-editor/font-plugin', 'post-editor/math-plugin', 'post-editor/image-plugin'], { });

